import { css } from "@emotion/core"
import { theme } from "../../atoms/constants"

export const otpContainerStyles = css`
  ${theme.presets.flexXYCentered};
`
export const loaderCss = css`
  margin: 10px 5px;
`
export const hideLoader = css`
  margin: 10px 5px;
  visibility: hidden;
`

export const wrappper = css`
  display: inline-block;
  position: relative;
  display: flex;
  width: 250px; //constant, if changed please adjust input multiplier too
`
export const inputStyle = (selectedIndex, hideInput) => {
  return css` 
  position: absolute;
  border: none !important;
  font-family: ${theme.fonts.primary};
  font-size: ${theme.fontSizes[4]};
  line-height: 24px;
  text-align: center;
  background-color: transparent !important; // not to be overridden by ant
  outline: none;
  width: 39px;
  top: 0px;
  bottom: 0px;    
  left: ${selectedIndex * 59}px; // input multiplier for left margin
  opacity: ${hideInput} ? 0 : 1;
  cursor: none;
  color: transparent;
`
}
export const otpInput = css`
  margin-right: 20px; //constant
  border: 1px solid ${theme.colors.purple[400]};
  width: 39px; // constant
  height: 50px;
  ${theme.presets.flexXYCentered};
  font-family: ${theme.fonts.primary};
  font-size: ${theme.fontSizes[4]};
  line-height: ${theme.lineHeights[0]}; //was 24px
  position: relative;
  background: ${theme.colors.purple[800]};
  border-radius: ${theme.radii[2]};
  color: ${theme.colors.text};
  &:last-child {
    border-right: none;
  }
`
export const selected = css`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  box-shadow: 0 0 0 4px rgba(58, 151, 212, 0.28);
`
